import type { HTMLAttributes } from 'react';
import { cn } from '@virginexperiencedays/tailwind';

export const Content = ({ children, className }: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('m-auto max-w-[1160px] p-4', className)}>{children}</div>;
};
